import camelize from 'camelcase-keys-deep';

export default class VehicleType {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }
}
